import React, { useCallback, useState } from 'react';
import {
  Col,
  Drawer,
  Row,
  Table,
} from 'antd';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import OnTraccrButton from '../common/buttons/OnTraccrButton';
import DrawerFooter from '../common/containers/DrawerFooter';
import { getBucketColumns } from './bucketHelpers';
import { safeExtractFromObject } from '../helpers/helpers';

export default function AddExistingBucketModal({
  title,
  bucketOptions,
  visible,
  onClose,
  onSave,
  submitValidation,
  downstreamKey,
}) {
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));
  const [selectedBuckets, setSelectedBuckets] = useState([]);

  const onSubmit = () => {
    if (submitValidation) {
      const isValid = submitValidation(selectedBuckets);
      if (!isValid) return;
    }
    onSave(selectedBuckets);
    setSelectedBuckets([]);
    onClose();
  };

  const columns = getBucketColumns();

  const onHeaderRow = useCallback(() => {
    if (!settings?.uxRedesignPt1) return null;
    return {
      className: 'ontraccr-table-header',
    };
  }, [settings]);

  return (
    <Drawer
      title={title}
      onClose={onClose}
      visible={visible}
      width={600}
      bodyStyle={{ padding: 20 }}
    >
      <Table
        columns={columns}
        dataSource={bucketOptions}
        rowSelection={{
          onChange: (newSelected) => setSelectedBuckets(newSelected),
          selectedRowKeys: selectedBuckets,
          getCheckboxProps: () => ({
            className: settings?.uxRedesignPt1 ? 'ontraccr-checkbox' : '',
          }),
        }}
        pagination={false}
        rowKey={({ id }) => id}
        size="small"
        style={{ width: '100%', height: 'calc(100vh - 181px)' }}
        scroll={{ y: 'calc(100vh - 220px)' }}
        onHeaderRow={onHeaderRow}
      />
      <DrawerFooter style={{ borderRadius: '0 0 20px 20px' }}>
        <Row justify="space-between" align="middle">
          <Col>
            <OnTraccrButton
              title="Cancel"
              type="cancel"
              onClick={onClose}
            />
          </Col>
          <Col>
            <OnTraccrButton
              title="Save"
              onClick={onSubmit}
              disabled={!selectedBuckets?.length}
            />
          </Col>
        </Row>
      </DrawerFooter>
    </Drawer>
  );
}

AddExistingBucketModal.propTypes = {
  title: PropTypes.string.isRequired,
  bucketOptions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
  })).isRequired,
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  downstreamKey: PropTypes.string.isRequired,
  submitValidation: PropTypes.func,
};

AddExistingBucketModal.defaultProps = {
  submitValidation: null,
};